export default "__VITE_ASSET__f2PJ3KIT__"